import { useTranslation } from 'next-i18next'

import RewardFrame from '~/bootcamp/pages/BootcampView/BootcampContent/RewardFrame'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function RewardSection({
  text,
  rewards,
  shouldHideRewardBackground = false,
}: {
  text?: string
  rewards: { gems: number; xp: number; kudos: number }
  shouldHideRewardBackground?: boolean
}): React.ReactElement {
  const { t } = useTranslation('avatar')
  const title = text ? text : t('rewards')
  return (
    <div className="relative text-white text-center self-end w-full z-20">
      {!shouldHideRewardBackground && (
        <ResponsiveImage
          className="absolute w-full bottom-0 left-0 md:left-[1px] right-0 mx-auto pb-12 md:pb-1.5"
          height={300}
          srcKey="bootcamp/reward-bg.svg"
          width={618}
        />
      )}
      <div className="relative z-10 h-36">
        <h3 className="text-h3 font-bold mb-2">{title}</h3>
        <div className="flex justify-center items-center space-x-4 mx-auto">
          {Boolean(rewards.gems) && (
            <RewardFrame
              amount={rewards.gems}
              icon={{
                alt: 'gems',
                srcKey: 'icons/gem-icon.png',
                height: 40,
                width: 40,
              }}
            />
          )}
          {Boolean(rewards.xp) && (
            <RewardFrame
              amount={rewards.xp}
              icon={{
                alt: 'xp',
                srcKey: 'gamification/xp.svg',
                height: 35,
                width: 35,
              }}
            />
          )}
          {Boolean(rewards.kudos) && (
            <RewardFrame
              amount={rewards.kudos}
              icon={{
                alt: 'kudos',
                srcKey: 'bootcamp/kudos-orb.png',
                height: 35,
                width: 35,
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
